/**
 * @generated SignedSource<<ab8a77fd70689892a8b363dd707d21fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsComponent$data = {
  readonly __typename: "ProductInfoRow";
  readonly row: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRow">;
  } | null;
  readonly " $fragmentType": "ProductDetailsComponent";
} | {
  readonly __typename: "ProductInfoSection";
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsSection">;
  readonly " $fragmentType": "ProductDetailsComponent";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ProductDetailsComponent";
};
export type ProductDetailsComponent$key = {
  readonly " $data"?: ProductDetailsComponent$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsComponent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsComponent",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "row",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProductDetailsRow"
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoRow",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsSection"
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoSection",
      "abstractKey": null
    }
  ],
  "type": "ProductStoreInfoComponent",
  "abstractKey": "__isProductStoreInfoComponent"
};
})();

(node as any).hash = "18aabe4900655e693a8475c99d9bf712";

export default node;
